<template>
	<div class="pcdetails">
		<el-backtop target=".pcdetails"></el-backtop>
		<div class="pchome-headerabo">
			<headers @ChangeEmit="ChangeEmit" ref="head"></headers>
		</div>
		<!-- <div class="productcab" :class="about_nav?'about_nav':''" >
			<div class="productc-rightab"  >
				<div class="right-detailab" :style="acindex==1?'color:'+nav_color:''" @click="acindexs(1)" >
					{{info.about}}
				</div>
				<div class="right-parameterab"  :style="acindex==2?'color:'+nav_color:''" @click="acindexs(2)">
					{{info.around}}
				</div>
				<div class="right-instructionsab"  :style="acindex==3?'color:'+nav_color:''" @click="acindexs(3)">
					{{info.honor}}
				</div>
				<div class="right-insnewsab"  :style="acindex==4?'color:'+nav_color:''" @click="acindexs(4)">
					{{info.news}}
				</div>
			</div>
		</div> -->
		<div class="productc" :class="about_nav?'about_nav':''">
			<div class="productc-left">
				{{about_us}}
			</div>
			<div class="productc-right">
				<div class="right-detail"  :style="acindex==1?'color:'+nav_color:''"  @click="acindexs(1)">
					{{info.about}}
				</div>
				<div class="right-instructions" :style="acindex==2?'color:'+nav_color:''" @click="acindexs(2)">
					{{info.around}}
				</div>
				<div class="right-parameter" :style="acindex==3?'color:'+nav_color:''" @click="acindexs(3)">
					{{info.honor}}
				</div>
<!--				<div class="right-maintain" :style="acindex==4?'color:'+nav_color:''" @click="acindexs(4)">-->
<!--					{{info.news}}-->
<!--				</div>-->
			</div>
		</div>
		<div style="padding:10px 0;opacity:0" v-if="about_nav">
			<div class="productc-left">
				{{about_us}}
			</div>
		</div>
		<div class="linesd" v-if="!acindex==2"></div>
		<div class="righttexab" v-if="acindex==1">
			<div class="abou-header">
				<div class="abouhea-cont">
					<div class="abouher-hea">{{info.about}}</div>
<!--					<div v-html="pcintrochtm" class="abouher-title"></div>-->
					<div class="abouher-title">
						<div v-for="(item,index) in pcintrochtm" :key="index">
							{{ item }}
						</div>
					</div>
				</div>
			</div>
			<div class="abou-center">
				<div class="aboucen-cont">
					<div class="abouitem-left">
						<div class="aboucen-item" >
							<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcaboutimg/pcabsense.svg"/>
							<div class="aboutcen-title">
								<div class="abcenttitle-hea">{{leftuscreated[0].ustitle}}</div>
								<div class="abcenttitle-foo">
									<div v-for="(item,index) in about_all.cost" :key="index">
										{{ item }}
									</div>
								</div>
							</div>
						</div>
						<div class="aboucen-item">
							<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcaboutimg/pcabcriterion.svg"/>
							<div class="aboutcen-title">
								<div class="abcenttitle-hea">{{rightuscreated[0].ustitle}}</div>
								<div class="abcenttitle-foo">
									<div v-for="(item,index) in about_all.rule" :key="index">
										{{ item }}
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="abouitem-right">
						<div class="aboucen-item">
							<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcaboutimg/pcabstyle.svg"/>
							<div class="aboutcen-title">
								<div class="abcenttitle-hea">{{leftuscreated[1].ustitle}}</div>
								<div class="abcenttitle-foo">
									<div v-for="(item,index) in about_all.style" :key="index">
										{{ item }}
									</div>
								</div>
							</div>
						</div>
						<div class="aboucen-item">
							<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcaboutimg/pcabvision.svg"/>
							<div class="aboutcen-title">
								<div class="abcenttitle-hea">{{rightuscreated[1].ustitle}}</div>
								<div class="abcenttitle-foo">
									<div v-for="(item,index) in about_all.vision" :key="index">
										{{ item }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

			</div>
			<div class="abou-chairman">
<!--				<div class="abouchairman-cont">-->
<!--					<div class="chaimancont-left">-->
<!--						<div class="text_position">-->
<!--							<div class="chaimanlef-position">{{chairman}}</div>-->
<!--&lt;!&ndash;							<div class="chaimanlef-title" v-html="about_all.say"></div>&ndash;&gt;-->
<!--							<div class="chaimanlef-title">-->
<!--								<img :src="about_all.say" alt="">-->
<!--							</div>-->
<!--						</div>-->

<!--					</div>-->
<!--					<div class="chaimancont-right">-->
<!--						<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcaboutimg/pic.png" />-->
<!--					</div>-->
<!--				</div>-->
        <div class="character-info">
          <div class="character-img">
            <img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260630/ebf5e2debca188ae478160da126b41ce.jpg" alt="">
          </div>
          <div class="character-desc">
            <h3>吴勋贤</h3>
            <h4>创始人、董事长</h4>
            <img class="txt-img" src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20260630/c94001c856192c4c48bbbabf491a4369.png" alt="">
          </div>
        </div>
			</div>
			<div class="abou-footer">
				<div class="aboufoo-heafer">{{info.course}}</div>
				<div class="aboufoo-cont">
					<div class="aboufoo-item" :class="joureycon==item.img_num?'':'routsscon'" v-for="(item,index) in companycours" :key="index">
						<div class="abfooitem-left">
							<div class="aboufoo-time">{{item.years}}</div>
							<div class="aboufoo-title" :style="courseTitleStyle()">
								<div v-for="(ite,idx) in item.content" :key="idx">
									{{ ite }}
								</div>
							</div>
							<div class="abouquimg">
								<div class="aboufoo-img" v-for="(image,inde) in item.images" :key="inde" >
									<img :src="image" />
								</div>

							</div>

						</div>
						<div class="lien-icon">
							<div class="abouicon"></div>
							<div class="aboulien"></div>
						</div>
					</div>
				</div>
				<div class="aboufoo-but">
					<div class="aboufoo-butcont" v-if="more_show"  @click="handleClickMore()" >{{info.more}}
					<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcaboutimg/pcabdown.svg" /></div>

				</div>

			</div>
			<div class="abou-video">
				<!--				<video id="video" controls :src="video_url"  :poster="img_url" ></video>-->
				<!-- <img :src="img_url"  @mousemove="video_in()" v-else class="video_title_image"> -->
				<div class="abou-video-container">
					<video-player  class="video-player vjs-custom-skin"
								   ref="videoPlayer"
								   :playsinline="true"
								   :options="playerOptions"
					></video-player>
				</div>
			</div>
		</div>
		<div class="parameter" v-if="acindex==2">
			<div class="abimgpubu">
				<div class="abimgpubu-item" v-for="(item,index) in companyarou" :key="index">
					<img :src="item.images" />
				</div>
			</div>
		</div>
		<div class="inshonor" v-if="acindex==3">
			<div class="abouhonor">
				<div class="abouhonor-hea">{{info.honor}}</div>
				<div class="abouhonor-foo">
					<div class="abouhonorfoo-item" v-for="item in comhonor">
						<img :src="item.images" />
					</div>
				</div>
			</div>
		</div>
		<div class="instructions" v-if="acindex==4">
			<div class="insnews-hea">{{info.news}}</div>
			<div class="insnews-cen">
				<div class="insnewscen-item"  :style="newnav==item.id?'color:'+nav_color:''"  v-for="(item,index) in pcnewtyp" @click="newnavcli(item.id)" :key="index">
					{{item.name}}
				</div>
			</div>
			<div class="insnew-foo">
				<!-- 新闻盒子 -->
				<div class="insnewfoo-item" v-for="(item,index) in newlists" @click="navtonewdetail(item.id)">
					<div class="fooitemnews-img">
						<img :src="item.image" />
					</div>
					<div class="fooitemnews-time">
						<div class="time-but">{{info.special}}</div>
						{{item.createtime}}
					</div>
					<div class="fooitemnews-title">{{item.title}}</div>
					<div class="fooitemnews-details">{{item.mark}}</div>
				</div>

			</div>
			<div class="pcabamorenew" v-if="newmoresc">
				<div class="pcabamorecont" @click="newmoresab()">
					{{info.more}}
					<img src="https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcaboutimg/pcabdown.svg" />
				</div>
			</div>
		</div>

		<footers ref=is_change></footers>

	</div>
</template>

<script>
	import '@/lib-flexible/flexible.js'
	import {session} from '../../storage/storage.js';
	import headers from '../../common/header.vue'
	import footers from '../../common/footers.vue'
	export default{
		data(){
			return{
				playing_video_id:0,
				about_nav:false,
				id:'',
				joureycon:1,
				more_show:true,//显示更多
				navheader:true,
				heshow:false,
				show: false,
				playli:true,
				playri:true,
				acindex:1,
				controls: true,
				year:"年",
				newnums:9,
				pcintrochtm:'',
        about_all:[],
				companycours:[],
				companyarou:'',
				comhonor:'',
				page:1,
				pcnewtyp:'',
				newlists:'',
				newnav:2,
				value: '',
				valuelang: '',
				newmoresc:true,
				about_us:"关于我们",
				video_url:'',
				img_url:'',
				info:{
            'about': "关于啄木鸟",
            'around': "公司环境",
            'honor': '公司荣誉',
            'news' : '新闻中心',
            'course' : '公司历程',
            'more' : "显示更多",
            'special': '专题',
        },
				leftuscreated :  [
					{'ustitle':'我们的核心价值观','usmintitle':'认真、诚信、感恩'},
					{'ustitle':'我们的作风','usmintitle':'想就有办法，做就做第一快、准、狠'},
				],
				rightuscreated : [
					{'ustitle':'我们的准则','usmintitle':'忠诚、认真、专业、创新、追求卓越以客户为核心,一切为客户而改变'},
					{'ustitle':'我们的愿景','usmintitle':'创世界一流企业，当中国崛起先锋,赢得全球客户的尊重和信赖，实现啄木鸟人的梦想'},
				],
				list_img: [],
				pubuimgs: [],
				nav_color:session.get('channel_id')==1?'#e62129':session.get('channel_id')==2?'#1a4698':'#5f5d5d',
				chairman_name:'',
				chairman:'',
				playerOptions : {
					playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
					autoplay: false, //如果true,浏览器准备好时开始回放。
					muted: false, // 默认情况下将会消除任何音频。
					loop: false, // 导致视频一结束就重新开始。
					preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
					language: 'zh-CN',
					aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
					fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
					sources: [{
						type: "video/mp4",//这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
						src: "" //url地址
					}],
					poster: "", //你的封面地址
					// width: document.documentElement.clientWidth, //播放器宽度
					notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
					controlBar: {
						timeDivider: true,
						durationDisplay: true,
						remainingTimeDisplay: false,
						fullscreenToggle: true  //全屏按钮
					}
				},
				pccompanycourseF:false
			}
		},
		components:{
			headers,
			footers
		},
		created() {
			// this.value=this.options[0].label
			// this.valuelang=this.optionslang[0].labellang
			this.getParams()
			this.pcintroduction()
			this.pccompanycourse()
			this.pccompanyaround()
			this.pccompanyhonor()
			this.pcnewtype()
			// this.pcnewlist()
			this.heshow=true

		},
		watch:{
			'$route': 'getParams'
		},
		mounted() {
			// document.getElementsByClassName('')
			// if(this.acindex== 4){
			// 	setTimeout(() => {
			// 	}, 1000);
			// }
			document.addEventListener('scroll',this.handleScroll,false)
			this.$once('hook:beforeDestroy', () => {
				document.removeEventListener('scroll', this.handleScroll,false)
			})

			if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
				console.log('手机手机21321321')
				let numb = this.$route.query.e
				if(numb == 3){
					this.$router.push({path:'./phhonor'})
				}else if(numb == 4){
					this.$router.push({path:'./phnews'})
				}else if(numb == 1){
					this.$router.push({path:'./phabout'})
				}else if(numb == 2){
					this.$router.push({path:'./phenviron'})
				}
			}
			sessionStorage.setItem('page',JSON.stringify({name:'pcabout',data:{e:this.$route.query.e}}))
		},
		methods: {
			newmoresab(){
				this.newnums+=5
				this.pcnewlist()
			},
			acindexs(e){
				this.acindex=e
				if(e == 4){
					setTimeout(() => {
					this.handleScroll()

					}, 100);
				}
				document.documentElement.scrollTop = 0
			},
			navtonewdetail(e){
				let typeid=this.newnav
				this.$router.push({path: '/pcnewdetail',query:{e,typeid}})
			},
			newnavcli(e){
				this.newnav=e
				this.pcnewlist()
			},
			video_in(){
				this.playing_video_id = 1
				setTimeout(() => {
					document.getElementById('video').play()
				}, 10);
			},
			video_out(){
				document.getElementById('video').pause()
				document.getElementById('video').currentTime = 0
				setTimeout(() => {
					this.playing_video_id = 0
				}, 10);
			},
      handleClickMore(){ // 点击显示更多

		  if(this.pccompanycourpccompanycourseseF){
		  	return
		  }
		  this.pccompanycourseF = true
        let data={
          lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
          channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
          mold:'pc',
          page: ++this.page,
          pageSize:5,
        }
        this.$api.get_company_course(data).then((res) => {
        	this.pccompanycourseF = false
          if (res.data.length == 0){
            this.more_show = false;
            return;
          }

			const data = res.data
			for(let i in data){
				this.companycours.push(data[i])
			}
			// this.companycours = this.companycours.concat(res.data)
          // res.data.forEach((el)=>{
          //   this.companycours.push(el);
          // })
        });
      },
			ChangeEmit(){ //子组件传递
				//主动调用子组件
				this.$refs.is_change.get_index_channel_data();
				this.$refs.is_change.pageParam();
				this.getParams()
				this.pcintroduction();//调用关于接口
				this.pageParam() //页面静态参数
				this.pccompanycourse() //历程
				this.pccompanyaround();
				this.pccompanyhonor();
				this.pcnewtype();
				this.pcnewlist();
			},
			//公司历程内容字号/行间距：后台"公司历程"页【字号设置】统一配置(按 1920 设计稿宽度填 px)，换算成 rem 与样式表保持一致的等比缩放
			courseTitleStyle(){
				const style = {}
				const size = parseFloat(this.about_all && this.about_all.course_font_size)
				if(size > 0){ style.fontSize = (size / 192) + 'rem' }
				const lineHeight = parseFloat(this.about_all && this.about_all.course_line_height)
				if(lineHeight > 0){ style.lineHeight = (lineHeight / 192) + 'rem' }
				return style
			},
			pcintroduction(){
				let data={
						lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
						channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),

					}
				this.$api.get_about_us(data).then((res) => {
            			this.about_all = res.data
					this.pcintrochtm=res.data.content
					this.video_url = res.data.url
					this.img_url = res.data.img
					this.playerOptions.sources = [{
						type: "video/mp4",
						src: res.data.url
					}]
					this.playerOptions.poster = res.data.img
				});
			},


			pccompanycourse(){
				if(this.pccompanycourseF){
					return
				}
				this.pccompanycourseF = true
				let data={
						lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
						channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
						mold:'pc',
						page:this.page,
						pageSize:5,
					}
				this.$api.get_company_course(data).then((res) => {
					const data = res.data
					for (let i in data){
						this.companycours.push(data[i])
					}
					this.pccompanycourseF = false

				})
			},

			pccompanyaround(){
				let data={
						lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
						channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
						mold:'pc',
						page:1,
						pageSize:5,

					}
				this.$api.get_company_around(data).then((res) => {
						this.companyarou=res.data
				});
			},

			pccompanyhonor(){
				let data={
						lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
						channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
						mold:'pc',

					}
				this.$api.get_company_honor(data).then((res) => {
						this.comhonor=res.data
				});
			},
			pcnewtype(){
				let data={
						lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
						channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
						mold:'pc',

					}
				this.$api.get_new_type(data).then((res) => {
						this.pcnewtyp = res.data
						if(res.data.length>0){
							this.newnavcli(res.data[0].id)
						}
				});
			},
			pcnewlist(){
				let data={
						type_id:this.newnav,
						lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
						channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
						mold:'pc',
						page:'1',
						pageSize:this.newnums,
					}
				this.$api.get_new_list(data).then((res) => {
						this.newlists=res.data

						if(this.newnums>this.newlists.length){
							this.newmoresc=false
						}
				});
				setTimeout(() => {
					this.handleScroll()
				}, 500);
			},
			pageParam(){
				let lang =  session.get("lang");
				if (lang === "cn"){
					this.leftuscreated =  [
						{'ustitle':'我们的核心价值观','usmintitle':'认真、诚信、感恩'},
						{'ustitle':'我们的作风','usmintitle':'想就有办法，做就做第一快、准、狠'},
					]
					this.rightuscreated =  [
						{'ustitle':'我们的准则','usmintitle':'忠诚、认真、专业、创新、追求卓越以客户为核心,一切为客户而改变'},
						{'ustitle':'我们的愿景','usmintitle':'创世界一流企业，当中国崛起先锋,赢得全球客户的尊重和信赖，实现啄木鸟人的梦想'},

          ]
		  this.chairman_name = '吴勋贤'
		  this.chairman = '董事长｜总经理'
          this.year = "年"
		  this.about_us = '关于我们'
          this.info = {
                'about': "关于啄木鸟",
                'around': "公司环境",
                'honor': '公司荣誉',
                'news' : '新闻中心',
                'course' : '公司历程',
                'more' : "显示更多",
                'special': '专题',
          }
				}else{

					this.created = "Woodpecker creation"
					this.leftuscreated =  [
						{'ustitle':'Corporate Core values','usmintitle':'Earnest, honest and grateful'},
						{'ustitle':'Corporate Principle','usmintitle':'Think there is a way, do it first, fast, accurate and obscene'},
					]
					this.rightuscreated =  [
						{'ustitle':'Corporate Faith','usmintitle':'Loyal, serious, professional, innovative, pursuing excellence, taking customers as the core and changing everything for customers'},
						{'ustitle':'Corporate Vision','usmintitle':'Create a world-class enterprise, be a pioneer in China, win the respect and trust of global customers, and realize the dream of woodpecker'},
					]
          this.year = "year"
		  this.chairman_name = 'XunXian Wu'
		  this.chairman = 'Chairman｜Manager'
		  this.about_us = 'ABOUT US'
          this.info = {
            'about': "About Woodpecker",
            'around': "Company Corner",
            'honor': 'Honors',
            'news' : 'News',
            'course' : 'History',
            'more' : "More",
            'special': 'Special',
          }

				}
			},
			handleScroll () {
			    let scrollTop = document.documentElement.scrollTop ||document.body.scrollTop
				// this.$refs.head.scrollTop_change(scrollTop)
				let head_height = this.$refs.head.getHeaderHeight()
				if(scrollTop>head_height){
					this.about_nav = true
					// if(scrollTop>this.scroll_height){
					// 	this.about_nav = true
					// }else{
					// 	this.about_nav = false
					// }
					// this.scroll_height = scrollTop
				}else{
					this.about_nav = false
				}
				this.$refs.head.scrollTop_change(scrollTop,'pcelites')
				if(this.acindex == 4){
					let item_list = document.getElementsByClassName("insnewfoo-item")
					if(item_list.length>0){
						for(let i=0;i<item_list.length;i++){
							const offset = item_list[i].getBoundingClientRect();
							const offsetTop = offset.top;
							const offsetBottom = offset.bottom;
							// const offsetHeight = offset.height;
							// 进入可视区域
							// console.log(offsetTop,offsetBottom)
							if (offsetTop <= window.innerHeight && offsetBottom >= 0) {
								// console.log('进入可视区域');
								item_list[i].style.animationName = 'insnewfoo_animation'
							}
						}
					}
				}
				if(this.acindex == 1){
					let item_list = document.getElementsByClassName("aboufoo-item")
					if(item_list.length>0){
						for(let i=0;i<item_list.length;i++){
							const offset = item_list[i].getBoundingClientRect();
							const offsetTop = offset.top;
							const offsetBottom = offset.bottom;
							// const offsetHeight = offset.height;
							// 进入可视区域
							// console.log(offsetTop,offsetBottom)
							if (offsetTop <= window.innerHeight && offsetBottom >= 0) {
								// console.log('进入可视区域');
								item_list[i].style.animationName = 'insnewfoo_animation'
							}
						}
					}
				}
			},
			nextimg(){
				let l = this.list_img.length;
				let scroll = document.getElementById('scroll-x');
				let diatance = scroll.scrollWidth - scroll.clientWidth;
				if(this.current_index == 0){
					this.current_index = l-1;
					scroll.scrollLeft = diatance;
				}else{
					this.current_index--;
					scroll.scrollLeft -= diatance / (l - 1);
				}
			},
			preimg(){
				let l = this.list_img.length;
				let scroll = document.getElementById('scroll-x');
				let diatance = scroll.scrollWidth - scroll.clientWidth;
				if(this.current_index+1 == l){
					this.current_index = 0;
					scroll.scrollLeft = 0;
				}else{
					this.current_index++;
					scroll.scrollLeft += diatance / (l - 1);
				}
			},
			hometo(){
				this.$router.push({path: '/pchome'})
			},
			videoto(){
				this.$router.push({path: '/pcvideos'})
			},
			queryto(){
				this.$router.push({path: '/pcquerys'})
			},
			productto(){
				this.$router.push({path: '/pcproduct'})
			},
			elitesto(){
				this.$router.push({path: '/pcelites'})
			},
			contactusto(){
				this.$router.push({path: '/pccontactus'})
			},
			aboutto(){
				this.$router.push({path: '/pcabout'})
			},
			seachto(){
				this.$router.push({path: '/pcseachs'})
			},
			enter(index){
			  this.navheader= true;
			},
			playenterli(){
				this.playli=false
			},

			playenterri(){
				this.playri=false
			},
			playleaveli(){
				this.playli=true
			},
			playleaveri(){
				this.playri=true
			},
			getParams () {
				let e = this.$route.query.e
				this.acindexs(e)
			}

		 }
	}
</script>

<style >
	body{
		margin: 0;
		padding: 0;
		background: #FAFAFA;
	}
	.pcdetails{
		width: calc(100vw);
		height: calc(100vh);
		/* overflow-x: hidden; */
		position: relative;
		background: #FAFAFA;
	}
	.pchome-headerabo{
		width: 100vw;
		position: relative;
		background-size: 100% 100%;
		padding-top: 79px;
		box-sizing: border-box;
	}
	.bb{
		background: #FAFAFA;
		position: fixed;
		top: 0;
		z-index: 99;
	}
	.aboutitem-hea{
		margin-top: 80px;
		margin-bottom: 40px;
		height: 33px;
		font-size: 24px;
		font-weight: 500;
		color: #FFFFFF;
		line-height: 33px;
		letter-spacing: 1px;
	}
	.aboutitem-fooitem{
		margin-bottom: 10px;
	}
	.fooitem-left{
		width: 110px;
		height: 32px;
		border-radius: 4px;
		border: 1px solid #EAEAEA;
		display: flex;
		align-items: center;
		justify-content: center;


		font-size: 16px;
		font-weight: 400;
		color: #FAFAFA;
		margin-right: 20px;
	}
	.fooitem-left img{
		width: 16px;
		height: 16px;
		margin-right: 6px;
	}
	.aboutitem-foosus{
		display: flex;
		margin-bottom: 20px;
	}
	.fooitem-right{
		font-size: 16px;
		font-weight: 400;
		color: #CCCCCC;
	}
	.fooitem-cont{
		margin-top: 25px;
		margin-left: 40px;
	}
	.fooitem-cont:first-child{
		margin-left: 0px;
	}
	.fooite-img{
		display: flex;
	}
	.fooite-img img{
		width: 90px;
		height: 90px;
	}
	.fooite-nam{
		text-align: center;
		margin-top: 20px;
	}
	.right-tit{
		margin-bottom: 5px;
	}
	.homefoot{

		height: 94px;
		background: #272727;
		border-top: 2px solid #666;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
	}
	.foot-hea{
		height: 22px;
		font-size: 16px;
		font-weight: 400;
		color: #666666;
		line-height: 22px;
	}
	.foot-f{
		height: 22px;
		font-size: 16px;
		font-weight: 400;
		color: #666666;
		line-height: 22px;
		margin-top: 10px;
		margin-bottom: 20px;
	}
	.productcab{
		width: 1400px;
		height: 80px;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 0 260px;
	}

	.productc-rightab{
		font-size: 16px;
		font-weight: 400;
		color: #5d5f5f;
		display: flex;
	}
	.right-detailab{
		margin-right: 24px;
		cursor: pointer;
	}
	.right-parameterab{
		margin-right: 24px;
		cursor: pointer;
	}
	.right-instructionsab{
		margin-right: 24px;
		cursor: pointer;
	}
	.right-insnewsab{
		margin-right: 24px;
		cursor: pointer;
	}
	.linesd{
		width: 100%;
		height: 1px;
		background: #EAEAEA;
	}
	.righttexab{
		display: flex;
		flex-direction: column;
	}
	.abou-header{
		width: 100%;
		height: 680px;
		display: flex;
		/*flex-direction: column;*/
		/* background: url(https://zmngw.oss-cn-shenzhen.aliyuncs.com/assets/pcaboutimg/banner.png) no-repeat; */
		background: url(https://zmngw.oss-cn-shenzhen.aliyuncs.com/uploads/20251209/ae802362913e259549fa2285d5da487b.jpg) no-repeat;
		/* background: url(../../assets/pcaboutimg/banner.png) no-repeat; */
		background-size: 1920px 100%;
		/*transform: rotateY(180deg)*/
	}
	.abouhea-cont{
		width: 1400px;
		/*display: flex;*/
		/*flex-direction: column;*/
		padding: 0px 260px;
		/*transform: rotateY(180deg)*/
	}
	.abouher-hea{
		font-size: 32px;
		font-weight: 500;
		color: #FFFFFF;
		letter-spacing: 1px;
		margin-top: 76px;
		margin-bottom: 32px;
	}
	.abouher-title{
		/* width: 756px; */
		/* width: 1450px; */
		color: #FFFFFF;
		font-size: 18px;
		line-height: 2;
		/* margin-top: -170px; */
	}
	.cc{
		color: #D03E3D;
	}
	.parameter{
		width: 1400px;
		display: flex;
		flex-direction: column;
		padding: 0px 260px;

	}
	.instructions{
		width: 1400px;
		display: flex;
		flex-direction: column;
		padding: 0px 260px;
		justify-content: center;
		align-items: center;
	}
	.abou-center{
		width: 1400px;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0px 260px;
		transform: rotateY(0)
	}
	.aboucen-cont{
		width: 1400px;
		/* height: 407px; */
		//background: #fff;
		border-radius: 20px;
		display: flex;
		padding-top: 60px;
		padding-bottom: 80px;
		padding-left: 122px;
		padding-right: 122px;
		box-sizing: border-box;
		//margin-top: -215px;
	}
	.abouitem-left{
		width: 701px;
		display: flex;

		flex-direction: column;
		//border-right: 1px solid #EAEAEA;
	}
	.aboucen-item{
		height: 90px;
	}
	.abouitem-left .aboucen-item{
		display: flex;
		/*align-items: center;*/
		margin-right: 123px;
	}
	.abouitem-right{
		width: 699px;
		display: flex;
		flex-direction: column;
	}
	.abouitem-right .aboucen-item{
		display: flex;
		/*align-items: center;*/
		margin-left: 123px;
	}
	.aboucen-item{
		margin-bottom: 85px;
	}
	.aboucen-item img{
		width: 80px;
		height: 80px;
	}
	.aboutcen-title{
		margin-left: 41px;

	}
	.abcenttitle-hea{
		font-size: 32px;
		font-weight: 600;
		color: #5d5f5f;
		letter-spacing: 1px;
	}
	.abcenttitle-foo{
		width: 335px;
		font-size: 18px;
		font-weight: 400;
		color: #666666;
		margin-top: 9px;
	}
	.abcenttitle-foo div {
		padding-bottom: 10px;
	}
	.abou-chairman{

	}
	.inshonor{
		width: 1400px;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0px 260px;
	}
	.abouchairman-cont{
		width: 1400px;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0px 260px;
	}
	.chaimancont-left{
		width: 680px;
		height: 449px;
		background: #D03E3D;
		border-radius: 20px;
		padding: 0 60px;
		margin-top: 189px;
		margin-right: -120px;
		z-index: 2;
	}
	.chaimanlef-hea{
		font-size: 40px;
		font-weight: 600;
		color: #FFFFFF;
		letter-spacing: 2px;
		margin-top: 60px;
	}
	.chaimanlef-position{
		font-size: 24px;
		font-weight: 600;
		color: #FFFFFF;
		letter-spacing: 1px;
		margin-top: 24px;
		margin-bottom: 24px;
	}
	.chaimanlef-title{
		font-size: 24px;
		font-weight: 400;
		color: #FFFFFF;
		letter-spacing: 1px;
		margin-bottom: 10px;
	}
	.chaimancont-left .text_position{
		padding-top: 80px;
	}
	.chaimanlef-title img{
		width: 100%;
		height: 100%;
		display: block;
		padding-top: 20px;
	}
	.chaimanlef-name{
		margin-right: 40px;
		text-align: right;
		font-size: 24px;
		font-weight: 400;
		color: #FFFFFF;
		letter-spacing: 1px;
		margin-top: 72px;
	}
	.chaimanlef-time{
		margin-top: 10px;
		margin-right: 40px;
		text-align: right;
		font-size: 24px;
		font-weight: 400;
		color: #FFFFFF;
		letter-spacing: 1px;

	}
	.chaimancont-right{
		margin-top: 80px;
		width: 840px;
		height: 485px;
	}
	.chaimancont-right img{
		width: 100%;
		height: 100%;
	}

  .character-img {
    width: 650px;
    background-color: #f3f2f2;
    border-radius: 20px;
    overflow: hidden;
  }
  .character-img img {
    display: block;
    width: 100%;
  }

	.abou-chairman{
		width: 1400px;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: 0px 260px;
	}


  .abou-chairman .character-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .abou-chairman .character-desc {
    color: #5d5f5f;
    margin-left: 200px;

  }
  .abou-chairman .character-desc h3,
  .abou-chairman .character-desc h4 {
    padding: 0;
    margin: 0;
  }
  .abou-chairman .character-desc .txt-img {
    width: 600px;
    margin-top: 150px;
  }
  .abou-chairman .character-desc {

  }
  .abou-chairman .character-desc h3 {
    font-size: 48px;
    font-weight: 500;
  }
  .abou-chairman .character-desc h4 {
    font-size: 40px;
    font-weight: 300;
    margin-top: 10px;
  }
  .abou-chairman .character-desc h5 {
    font-size: 26px;
  }
  .abou-chairman .character-desc p {
    font-size: 24px;
  }

	.abou-footer{
	}
	.aboufoo-cont{
		width: 1400px;
		padding: 0px 260px;
	}
	.lien-icon{
		display: flex;
		align-items: center;
		position: relative;
		margin-left: 99px;
		margin-right: 100px;
	}
	.abouicon{
		width: 15px;
		height: 15px;
		border-radius: 50%;
		background: #D8D8D8;
		position: absolute;
		top: 0px;
		left: -7px;
	}
	.aboulien{
		width: 1px;
		height: 600px;
		background: #EAEAEA;
	}
	.aboufoo-item:nth-child(odd) .abfooitem-left {
		text-align: right;
	}
	.aboufoo-item:nth-child(even) .abfooitem-left{
		text-align: left;
	}
	.aboufoo-item{
		display: flex;
		margin-top: -240px;
		opacity: 0;
		animation-duration: 1s;
		animation-fill-mode: forwards;
		transform: translateY(30%);
	}
	.aboufoo-item:first-child{
		margin-top: 0px;
	}
	.aboufoo-item:nth-child(2n){
		display: flex;
		flex-direction: row-reverse;
		/*text-align: right;*/
		/*text-align: left;*/
	}
	.aboufoo-img{
		margin-top: 40px;
		width: 600px;
		height: 350px;
		border-radius: 22px;
		-webkit-border-radius:22px;
		-ms-border-radius:22px;
		-o-border-radius:22px;
		-moz-border-radius:22px;
		overflow: hidden;
		transform: rotate(0deg);
	}
	.aboufoo-img:hover img{
		cursor: pointer;
		width: 600px;
		height: 350px;
		border-radius: 20px;
		transform: scale(1.1,1.1);
	}
	.aboufoo-img img{
		width: 600px;
		height: 350px;
		transition: all 1s linear;
	}
	.aboufoo-time{
		font-size: 18px;
		font-weight: 400;
		color: #5d5f5f;
	}
	.aboufoo-title{
		width: 600px;
		font-size: 22px;
		font-weight: 400;
		color: #5d5f5f;
		letter-spacing: 1px;
		line-height : 40px ;
		margin-top: 15px;
	}
	.aboufoo-heafer{
		margin-top: 80px;
		margin-bottom: 80px;
		width: 1400px;
		padding: 0 260px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 40px;
		font-weight: 600;
		color: #5d5f5f;
		letter-spacing: 2px;
	}
	.aboufoo-but{
		width: 1400px;
		padding: 0 260px;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 40px;
		font-weight: 600;
		color: #5d5f5f;
		letter-spacing: 2px;
		margin-top: 60px;
		cursor: pointer;
	}
	.aboufoo-butcont{
		width: 100px;
		height: 32px;
		border-radius: 4px;
		border: 1px solid #CCCCCC;
		font-size: 14px;
		font-weight: 400;
		color: #999999;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.aboufoo-butcont img{
		width: 14px;
		height: 14px;
		margin-left: 6px;
	}
	.abou-video{
		width: 1400px;
		/* padding: 0 260px; */
		margin: 80px 260px ;

	}
	.abou-video-container{
		border-radius: 22px;
		-webkit-border-radius:22px;
		-ms-border-radius:22px;
		-o-border-radius:22px;
		-moz-border-radius:22px;
		overflow: hidden;
		-webkit-backface-visibility: hidden;
		-webkit-transform: translate3d(0, 0, 0);
	}
	.abou-video .vjs-control-text {
		display: none;
	}
	.abou-video .video-js,
	.abou-video .vjs-poster {
		background-color: rgba(0,0,0,0);
	}
	.abou-video video{
		width: 1400px;
		height: 788px;
		/*border-radius: 20px;*/
	}
	.abou-video img{
		width: 1400px;
		height: 788px;
		/* border-radius: 20px; */
	}
	.abouhonor-hea{
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 40px;
		font-weight: 600;
		color: #5d5f5f;
		letter-spacing: 2px;
		margin-top: 60px;
		margin-bottom: 60px;
	}
	.abouhonor-foo{
		display: flex;
		flex-wrap: wrap;
	}
	.abouhonorfoo-item{
		margin-right: 40px;
		margin-bottom: 40px;
		width: 320px;
		height: 200px;
		border-radius: 22px;
		-webkit-border-radius:22px;
		-ms-border-radius:22px;
		-o-border-radius:22px;
		-moz-border-radius:22px;
		overflow: hidden;
		transform: rotate(0deg);
	}
	.abouhonorfoo-item:nth-child(4n){
		margin-right: 0px;
	}
	.abouhonorfoo-item:hover img{
		cursor: pointer;
		width: 320px;
		height: 200px;
		transform: scale(1.02,1.02);
	}
	.abouhonorfoo-item img{
		width: 320px;
		height: 200px;
		transition: all 1s linear;
	}
	.insnews-hea{
		font-size: 40px;
		font-weight: 600;
		color: #5d5f5f;
		letter-spacing: 2px;
		margin-top: 60px;
	}
	.insnews-cen{
		display: flex;
		margin-top: 40px;
	}
	.insnewscen-item{
		margin-right: 40px;
		cursor: pointer;
		font-size: 16px;
	}
	.insnewscen-item:last-child{
		margin-right: 0px;
	}
	.fooitemnews-img{
		width: 440px;
		height: 250px;
		border-radius: 22px;
		-webkit-border-radius:22px;
		-ms-border-radius:22px;
		-o-border-radius:22px;
		-moz-border-radius:22px;
		transform: rotate(0deg);
		overflow: hidden;
	}
	.fooitemnews-img:hover img{
		cursor: pointer;
		width: 440px;
		height: 250px;
		transform: scale(1.02,1.02);
	}
	.fooitemnews-img img{
		width: 440px;
		height: 250px;
		border-radius: 20px;
		transition: all .75s linear;
	}
	.insnew-foo{
		margin-top: 60px;
		width: 1400px;
		display: flex;
		flex-wrap: wrap;
	}
	.insnewfoo-item{
		width: 440px;
		padding-bottom: 20px;
		box-sizing: border-box;
		margin-right: 40px;
		margin-bottom: 40px;

		opacity: 0;
		transform: translateY(30%);

		animation-duration: 1s;
		animation-fill-mode: forwards;
	}
	.insnewfoo-item:nth-child(3n){
		margin-right: 0px;
	}
	@keyframes insnewfoo_animation{
		0%{}
		100%{
			opacity: 1;
			transform: translateY(0%);
		}
	}
	.fooitemnews-time{
		margin-top: 20px;
		display: flex;
		align-items: center;
		font-size: 16px;
	}
	.time-but{
		/* width: 50px; */
		padding: 0 5px;
		height: 26px;
		background: #D03E3D;
		border-radius: 5px;
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 12px;
		font-size: 16px;
		color: #fff;
	}
	.fooitemnews-title{
		width: 440px;
		white-space: pre-wrap;
		font-size: 24px;
		font-weight: 600;
		color: #5d5f5f;
		letter-spacing: 1px;
		margin-top: 22px;
	}
	.fooitemnews-details{
		white-space: pre-wrap;
		width: 440px;
		font-size: 16px;
		font-weight: 500;
		color: #999999;
		margin-top: 20px;
	}
	.abimgpubu{
		margin: 40px;
		column-count: 2;
		column-gap: 40px;
	}
	.abimgpubu-item{
		margin-bottom: 40px;
		border-radius: 22px;
		-webkit-border-radius:22px;
		-ms-border-radius:22px;
		-o-border-radius:22px;
		-moz-border-radius:22px;
		overflow: hidden;
		transform: rotate(0deg);
	}
	.abimgpubu-item img{
		width: 100%;
		height:100%;
		display: block;
		transition: all 1s linear;
	}
	.abimgpubu-item:hover img{
		cursor: pointer;
		transform: scale(1.1,1.1);
	}
	.newcla{
		color: #D03E3D;
	}
	.routsscon .abouquimg{
		display: flex;
		flex-wrap: wrap;
		width: 600px;
	}
	.routsscon .aboufoo-img{
		display: flex;
		flex-wrap: wrap;
		width: 280px;
		height: 200px;
		margin-right: 20px;
		margin-bottom: 20px;
		/*transition: all 1s;*/

	}
	.routsscon .aboufoo-img:hover img{
		width: 280px;
		height: 200px;
		transform: scale(1.02,1.02);
	}
	.routsscon .aboufoo-img  img{
		width: 280px;
		height: 200px;
		transition: all .75s linear;
	}
	.abouquimg{
		width: 600px;
	}
	/* .header-nav{
		width: 1400px;
		height: 79px;
		display: flex;
		align-items: center;
		padding: 0 260px;
		position: fixed;
		top: 0;
	} */
	.nav-wit{

	}
	.nav-left{
		width: 100px;
		height: 50px;
	}
	.nav-left img{
		width: 100%;
		height: 100%;
	}
	/* .nav-center-item:hover{
		border-bottom: 2px solid #E31E24;
	} */

	.nav-center-item:first-child{
		margin-left: 0;
	}
	.nav-right{
		display: flex;
		align-items: center;
		color: #fff;
		font-size: 16px;
		font-weight: 400;
		margin-left: 180px;
	}
	.nav-right .search{
		display: flex;
		align-items: center;
		width: 20px;
		height: 20px;
		margin-right: 20px;
		cursor: pointer;
	}
	.nav-right .search img{
		width: 100%;
		height: 100%;
	}
	.nav-right .homename{
		display: flex;
		align-items: center;
		justify-content: center;
		margin-right: 20px;
		cursor: pointer;
	}
	.nav-right .homename img{
		width: 16px;
		height: 16px;
		margin-left: 4px;
	}
	.nav-right .language{
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}
	.nav-right .language img{
		width: 16px;
		height: 16px;
		margin-left: 6px;
	}
	.pcabamorenew{
		display: flex;
		justify-content: center;
		align-items: center;
		margin-bottom: 30px;
		cursor: pointer;
	}
	.pcabamorecont{
		width: 130px;
		height: 40px;
		border: 1px solid #999;
		color: #999;
		border-radius: 6px;
		font-size: 20px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.pcabamorecont img{
		width: 20px;
		height: 20px;
	}
	.about_nav{
		top: 0;
		position: fixed;
		z-index: 9;
		background-color: #fff;
		background: rgba(255,255,255,.72);
    	backdrop-filter: saturate(180%) blur(20px);
	}
	.productc{
		width: 1400px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 10px 260px;
		background: rgba(255,255,255,.72);
		backdrop-filter: saturate(180%) blur(20px);
	}
	.productc-left{
		font-size: 28px;
		font-weight: 500;
		color: #5d5f5f;
	}
	.productc-right{
		font-size: 16px;
		font-weight: 400;
		color: #5d5f5f;
		display: flex;
	}
	.right-detail{
		margin-right: 24px;
		cursor: pointer;
	}
	.right-parameter{
		margin-right: 24px;
		cursor: pointer;
	}
	.right-instructions{
		margin-right: 24px;
		cursor: pointer;
	}
	.right-maintain{
		cursor: pointer;
	}
</style>
